module.exports = __webpack_public_path__ + "static/media/32-14.986c68f7.mp3";